import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, useParams } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ShopHomePage from './pages/ShopHomePage';
import CheckoutPage from './pages/CheckoutPage';
import OrderSuccess from './pages/OrderSuccess';
import TemplatedMenuPage from './pages/TemplatedMenuPage';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8081';

function App() {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />
      <Switch>
        <Route exact path="/restaurant/:restaurantId" component={TemplatedMenuPage} />
        <Route exact path="/:shopCode" component={ShopHomePage} />
        <Route path="/:shopCode/checkout" component={CheckoutPage} />
        <Route path="/:shopCode/order-success/:orderId" component={OrderSuccess} />
      </Switch>
    </Router>
  );
}

export default App;
